// extracted by mini-css-extract-plugin
export var banner = "_sc-0";
export var settingRow = "_sc-2";
export var titleIcon = "_sc-1";